export default __webpack_public_path__ + "static/media/BootsSharp-Bold.43defbb2.eot";